import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import qs from 'qs'

class Items {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })
    this.items = base
    this.cancelTokenSource = null
  }

  async getSources () {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: '/sources',
      method: 'GET'
    })
  }

  async getSourceRelsByPartyId (partyId) {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/source/relationships/party/${partyId}`,
      method: 'GET'
    })
  }

  async getSourceRels () {
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/sources/relationships`,
      method: 'GET'
    })
  }

  async searchItems (data = {}, offset = 0, limit = 50) {
    this.cancelTokenSource = axios.CancelToken.source()
    try {
      await AuthToken.setAuth(this.items)
      
      const response = await this.items({
        url: '/search/order-entry',
        method: 'POST',
        params: { offset, limit },
        data,
        cancelToken: this.cancelTokenSource.token
      })
      return response
    } catch (error) {
      if (axios.isCancel(error)) {
        throw new Error('Search was cancelled by user')
      }
      throw error
    }
  }
  
  cancelSearchItems () {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel()
      this.cancelTokenSource = null
    }
  }

  async getPossibleValues (column, downstream_column = null, sources = [], is_retailer = false) {
    const params = { sources, is_retailer, downstream_column }
    await AuthToken.setAuth(this.items)
    return this.items({
      url: `/possible_values/${column}`,
      method: 'GET',
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false, encode: false })
      }
    })
  }
}

export default new Items()